import * as React from "react";
const SvgFiRrPotato = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-potato_svg__a)">
      <path
        fill="#062147"
        d="M20.568 1.105a7.2 7.2 0 0 0-7.748.022 7.26 7.26 0 0 0-2.524 2.72c-.761 1.427-1.897 2.358-3.2 2.621-2.438.493-4.504 1.947-5.817 4.096-2.126 3.481-1.533 8.075 1.41 10.925a8.84 8.84 0 0 0 6.177 2.504c8.2 0 15.128-7.648 15.128-16.703 0-2.504-1.28-4.816-3.425-6.186zM8.865 21.993a6.85 6.85 0 0 1-4.786-1.94c-2.276-2.205-2.736-5.757-1.094-8.446 1.02-1.668 2.62-2.797 4.507-3.179 1.898-.383 3.52-1.676 4.568-3.64a5.3 5.3 0 0 1 1.842-1.979 5.2 5.2 0 0 1 2.815-.813c.974 0 1.945.265 2.774.794 1.588 1.015 2.5 2.655 2.5 4.5 0 7.97-6.01 14.703-13.126 14.703M18 7.5a1.5 1.5 0 1 1-3.002 0A1.5 1.5 0 0 1 18 7.5m-9 7a1.5 1.5 0 1 1-3.002 0A1.5 1.5 0 0 1 9 14.5m9-1a1.5 1.5 0 1 1-3.002 0 1.5 1.5 0 0 1 3.002 0"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-potato_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPotato;
